export default function Configs(that) {
    const searchItems = [
        {
            label: "身份证号",
            span: 8,
            placeholder: '请输入身份证号',
            model: "idCard"
        },
        {
            label: "学号",
            prop: "studentNo",
            span: 8,
            placeholder: '请输入学生学号',
            model: "studentNo"
        },
        {
            label: "姓名",
            span: 8,
            placeholder: '请输入姓名',
            model: "studentName"
        },
    ]
    const tableColumns = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "系别",
            prop: "departmentName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 150,
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "操作",
            name: 'contr',
            align: "center",
            show: true
        },
    ]

    const tableColumnsAudit = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "系别",
            prop: "departmentName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 150,
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            show: true,
            minWidth: 160,
        },
        // {
        //     label: "任务到期时间",
        //     prop: "startTime",
        //     align: "center",
        //     show: true
        // },
        {
            label: "操作",
            name: 'contr',
            align: "center",
            show: true
        },
    ]
    const tableColumnsReviewed = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true,
            // minWidth:140,
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "系别",
            prop: "departmentName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 150,
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "办理时间",
            prop: "updateTime",
            align: "center",
            show: true,
            minWidth: 260,
        },
        {
            label: "办理意见",
            name: 'status',
            // prop: "status",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: 'contr',
            align: "center",
            show: true
        },
    ]


    return {
        searchItems,
        tableColumns,
        tableColumnsAudit,
        tableColumnsReviewed
    }
}